import { Box } from "@mui/material"
import { Task, DeleteForever } from "@mui/icons-material"
import { TopToolbar, useGetIdentity, useGetOne, useRecordContext } from 'react-admin'
import { InvoiceReadModel, ReverseInvoiceReadModel, UserReadModel } from '../GeneratedClients/FreeBillApi'
import CreateBookingTransactionDialog from './actionDialogs/CreateBookingTransactionDialog'
import DownloadPdfButton from './actionButtons/DownloadPdfButton'
import SendReverseInvoiceButton from './actionButtons/SendReverseInvoiceButton'
import BreadCrumbs from "../invoiceCorrelations/BreadCrumbs"

const ReverseInvoiceShowActions = () => {
  
  const reverseInvoice = useRecordContext<ReverseInvoiceReadModel>()
  const { data: identity, isLoading: identityLoading } = useGetIdentity()
  //@ts-ignore
  const { data: user, isLoading: userLoading} = useGetOne<UserReadModel>("users", {id: identity?.id}, {enabled: !reverseInvoice})
  //@ts-ignore
  const { data: invoice } = useGetOne<InvoiceReadModel>("invoices", {id: reverseInvoice?.canceledInvoiceId}, {enabled: !reverseInvoice})

  if(!reverseInvoice || identityLoading || userLoading) return null

  return (
    <TopToolbar>
      <Box display={"flex"} justifyContent={"space-between"} width={"100%"}>
        <Box pt={0.5}>
          <BreadCrumbs 
            links={[
              {
                title: invoice?.textModel?.heading, 
                href: `/#/invoices/${reverseInvoice.canceledInvoiceId}/show`,
                icon: <Task sx={{ mr: 0.5 }} fontSize="inherit" />
              },
              {
                title: reverseInvoice.textModel?.heading, 
                href: `/#/reverseInvoices/${reverseInvoice.id}/show`,
                icon: <DeleteForever sx={{ mr: 0.5 }} fontSize="inherit" />
              }
            ]}
          />
        </Box>
        <Box>
          <CreateBookingTransactionDialog reverseInvoice={reverseInvoice} />
          <DownloadPdfButton />
          <SendReverseInvoiceButton user={user} />
        </Box>
      </Box>
    </TopToolbar>
  )
}

export default ReverseInvoiceShowActions